export const getTruncatedString = (value: string, maxLen: number) =>
  value.length <= maxLen ? value : `${value.substring(0, maxLen - 3)}...`;
